import { cn } from './cn';

/**
 * The shape of every row in the rail — a destination, a footer control, the
 * account. FleetSight's: 13px medium, a 12px corner, the glyph growing a step
 * on hover.
 *
 * 44px on a phone, natural height from `md` up. The 44px floor in `base.css`
 * covers buttons but never covered links, and the rows are links.
 *
 * The console's rail is built from the same three constants, so its rows sit at
 * the same height, take the same corner and light up the same way.
 */
export const NAV_ROW =
  'group relative flex w-full min-h-[44px] md:min-h-0 items-center rounded-lg px-2 py-1.5 ' +
  'text-sm font-medium transition-colors focus-visible:outline-2 focus-visible:outline-offset-2';

/** The glyph in a row: scales up on hover, down on press. */
export const NAV_GLYPH =
  'size-4 shrink-0 transition-transform duration-200 ease-out group-hover:scale-115 group-active:scale-90';

/** Selected, or merely available. */
export function navRowState(isActive: boolean) {
  return isActive
    ? 'bg-sidebar-accent text-sidebar-accent-foreground'
    : 'text-muted-foreground hover:bg-sidebar-accent/60';
}

/** A gap beside a zero-width label still pushes the glyph off centre, so it goes too. */
export function navRowLayout(isCollapsed: boolean) {
  return isCollapsed ? 'justify-center gap-0' : 'gap-2.5';
}

/** Labels stay mounted and fade, so the width change reads as one motion. */
export function navLabel(isCollapsed: boolean, extra?: string) {
  return cn(
    'truncate transition-[opacity,width] duration-150',
    isCollapsed ? 'w-0 flex-none opacity-0' : 'opacity-100',
    extra
  );
}
